import React, { useState } from 'react';
import { Loader2, Sparkles } from 'lucide-react';
import { toast } from 'sonner';
import api from '@/lib/api';
import { Button } from '@/components/ui/button';
import { C, Notice, Panel } from '@/design-system/dna';
import { errMsg } from './shared';

const TIPOS = [['agrupamentos', 'Sugerir agrupamentos de reforço'], ['atividades', 'Atividades graduadas'], ['explicacoes', 'Explicações alternativas'], ['evolucao', 'Análise de evolução']];

/** IA assistiva: só sugere, a partir de registros agregados autorizados. Nunca diagnostica nem decide. */
export function AiAssist({ filtros, year }) {
  const [busy, setBusy] = useState(null);
  const [out, setOut] = useState(null);
  const run = async (tipo) => {
    setBusy(tipo); setOut(null);
    try {
      const p = Object.fromEntries(Object.entries(filtros).filter(([, v]) => v !== 'all'));
      const { data } = await api.post('/dna-mapa/ia/sugestoes', { tipo, year, ...p });
      setOut(data);
    } catch (e) { toast.error(errMsg(e, 'IA indisponível.')); } finally { setBusy(null); }
  };
  return (
    <Panel title="IA assistiva" kicker="Sugestões para validação do profissional" testid="dna-ia">
      <div className="flex flex-wrap gap-2">{TIPOS.map(([k, l]) => <Button key={k} size="sm" variant="outline" onClick={() => run(k)} disabled={!!busy} data-testid={`dna-ia-${k}`}>{busy === k ? <Loader2 className="h-4 w-4 animate-spin" /> : <Sparkles className="h-4 w-4" />} {l}</Button>)}</div>
      <p className="mt-2 text-[11.5px]" style={{ color: C.muted }}>A IA recebe apenas dados pedagógicos agregados e pseudonimizados, não atribui diagnóstico clínico, não rotula estudantes e não decide a necessidade de reforço.</p>
      {out && <div className="mt-3 space-y-2" data-testid="dna-ia-resultado"><Notice tone="warning">Sugestão gerada por IA — revise e valide antes de aplicar.</Notice><pre className="whitespace-pre-wrap rounded-2xl p-4 font-[inherit] text-[13px]" style={{ background: C.paper, color: C.ink }}>{out.texto}</pre></div>}
    </Panel>
  );
}
